import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class RmsSubLimitsUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getRmsSublimits(req);
    }
}
export default RmsSubLimitsUseCase;
